// Copyright (c) Microsoft. All rights reserved.

import { FC, useState } from 'react';

import { Button, makeStyles } from '@fluentui/react-components';
import { useChat } from '../../../../libs/hooks';
import { Add20 } from '../../../shared/BundledIcons';
import { InvitationJoinDialog } from '../../invitation-dialog/InvitationJoinDialog';
import { Breakpoints } from '../../../../styles';

const useClasses = makeStyles({
    button: {
        marginLeft: '-15px',
        ...Breakpoints.small({
            marginLeft: 'unset',
        }),
    },
    buttonLabel: {
        ...Breakpoints.small({
            display: 'none',
        }),
    },
});

interface SimplifiedNewBotMenuProps {
    onFileUpload: () => void;
}

export const SimplifiedNewBotMenu: FC<SimplifiedNewBotMenuProps> = () => {
    const classes = useClasses();
    const chat = useChat();

    // It needs to keep the menu open to keep the FileUploader reference
    // when the file uploader is clicked.
    const [isJoiningBot, setIsJoiningBot] = useState(false);

    const onAddChat = () => {
        void chat.createChat();
    };

    const onCloseDialog = () => {
        setIsJoiningBot(false);
    };

    return (
        <div>
            <Button
                data-testid="createNewConversationButton"
                className={classes.button}
                icon={<Add20 />}
                appearance="transparent"
                onClick={onAddChat}
            >
                <span className={classes.buttonLabel}>Neuer Chat</span>
            </Button>
            {isJoiningBot && <InvitationJoinDialog onCloseDialog={onCloseDialog} />}
        </div>
    );
};
